/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Billing_Upcoming_InvoiceInputs */



/**
* | output |
* | --- |
* | "Upcoming Invoice" |
*
* @param {Sub_Billing_Upcoming_InvoiceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_billing_upcoming_invoice = /** @type {((inputs?: Sub_Billing_Upcoming_InvoiceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Billing_Upcoming_InvoiceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nächste Rechnung")
	return /** @type {LocalizedString} */ ("Upcoming Invoice")
});